<!-- THIS COMPONENT IS FOR PATIENT AND PROVIDER MODALS -->
<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>
          <v-row justify="space-between">
            <v-col cols="6" class="py-0">
              <v-card-title primary-title>Notifications</v-card-title>
            </v-col>
          </v-row>
          <v-card-text>
            <v-row>
              <v-col cols="6" class="pt-0">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0">
                <v-select
                  v-on:change="getSelected()"
                  v-model="filterSelection"
                  :items="filterOptions"
                  :menu-props="{ maxHeight: '400' }"
                  label="Discharge Disposition"
                  clearable
                  return-object
                >
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card-title>
        <v-data-table
          :loading="load"
          :headers="headers"
          :items="tableData"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="_id"
          show-expand
          :search="search"
          sort-by="notifications[0].data.EVENT_TIME"
          :sort-desc="true"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50]
          }"
          :items-per-page="25"
          class="elevation-1 col-md-12"
        >
          <template v-slot:expanded-item="{ headers, item }" style="padding: 100px;">
            <td :colspan="headers.length">
              <tr>
                <th class="sub-notifications-header">EVENT TIME</th>
                <th class="sub-notifications-header">EVENT TYPE</th>
                <th class="sub-notifications-header">SOURCE PT CLASS</th>
                <th class="sub-notifications-header">SOURCE FACILITY</th>
                <th class="sub-notifications-header">READMISSION INDICATOR</th>
                <th class="sub-notifications-header">EPISODE ID</th>
                <th class="sub-notifications-header">VISIT NUMBER</th>
                <th class="sub-notifications-header">PATIENT COMPLAINT</th>
                <th class="sub-notifications-header">ADMIT TYPE</th>
                <th class="sub-notifications-header">ADMIT SOURCE</th>
                <th class="sub-notifications-header">HOSPITAL SERVICE</th>
                <th class="sub-notifications-header">
                  ATTENDING PHYSICIAN LAST
                </th>
                <th class="sub-notifications-header">
                  ATTENDING PHYSICIAN FIRST
                </th>
                <th class="sub-notifications-header">DIAGNOSIS DESCRIPTION</th>
                <th class="sub-notifications-header">DIAGNOSIS CODE</th>
                <th class="sub-notifications-header">DIAGNOSIS TYPE</th>
                <th class="sub-notifications-header">ADMIT TIMESTAMP</th>
                <th class="sub-notifications-header">DISCHARGE TIMESTAMP</th>
                <th class="sub-notifications-header">DISCHARGE DISPOSITION</th>
                <th class="sub-notifications-header">DISCHARGE TO LOCATION</th>
                <th class="sub-notifications-header">DEATH INDICATOR</th>
                <th class="sub-notifications-header">DATE OF DEATH</th>
                <th class="sub-notifications-header">MBI</th>
              </tr>
              <tr v-for="(n, index) in item.notifications" :key="index">
                <td class="sub-notifications">{{ n.data.EVENT_TIME ? n.data.EVENT_TIME.substring(0, 10) : "-" }}</td>
                <td class="sub-notifications">
                  <v-chip dark :color="colorEvent(n.data.EVENT)">{{
                    n.data.EVENT ? n.data.EVENT : "-"
                  }}</v-chip>
                </td>
                <td class="sub-notifications">
                  <v-chip dark :color="colorSourceClass(n.data.SOURCE_PTCLASS)">{{
                    n.data.SOURCE_PTCLASS ? n.data.SOURCE_PTCLASS : "-"
                  }}</v-chip>
                </td>
                <td class="sub-notifications">
                  {{ n.data.SOURCE_FACILITY ? n.data.SOURCE_FACILITY : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.READMISSION_INDICATOR ? n.data.READMISSION_INDICATOR : "-" }}
                </td>
                <td class="sub-notifications">{{ n.data.EPISODE_ID ? n.data.EPISODE_ID : "-" }}</td>
                <td class="sub-notifications">
                  {{ n.data.VISIT_NUMBER ? n.data.VISIT_NUMBER : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.PATIENT_COMPLAINT ? n.data.PATIENT_COMPLAINT : "-" }}
                </td>
                <td class="sub-notifications">{{ n.data.ADMIT_TYPE ? n.data.ADMIT_TYPE : "-" }}</td>
                <td class="sub-notifications">
                  {{ n.data.ADMIT_SOURCE ? n.data.ADMIT_SOURCE : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.HOSPITAL_SERVICE ? n.data.HOSPITAL_SERVICE : "-" }}
                </td>
                <td class="sub-notifications">
                  {{
                    n.data.ATTENDING_PHYSICIAN_LAST_NAME
                      ? n.data.ATTENDING_PHYSICIAN_LAST_NAME
                      : "-"
                  }}
                </td>
                <td class="sub-notifications">
                  {{
                    n.data.ATTENDING_PHYSICIAN_FIRST_NAME
                      ? n.data.ATTENDING_PHYSICIAN_FIRST_NAME
                      : "-"
                  }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DIAGNOSIS_DESCRIPTION ? n.data.DIAGNOSIS_DESCRIPTION : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DIAGNOSIS_CODE ? n.data.DIAGNOSIS_CODE : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DIAGNOSIS_TYPE ? n.data.DIAGNOSIS_TYPE : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.ADMIT_TIMESTAMP ? n.data.ADMIT_TIMESTAMP : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DISCHARGE_TIMESTAMP ? n.data.DISCHARGE_TIMESTAMP : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DISCHARGE_DISPOSITION ? n.data.DISCHARGE_DISPOSITION : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DISCHARGE_TO_LOCATION ? n.data.DISCHARGE_TO_LOCATION : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DEATH_INDICATOR ? n.data.DEATH_INDICATOR : "-" }}
                </td>
                <td class="sub-notifications">
                  {{ n.data.DATE_OF_DEATH ? n.data.DATE_OF_DEATH : "-" }}
                </td>
                <td class="sub-notifications">{{ n.data.MBI ? n.data.MBI : "-" }}</td>
              </tr>
            </td>
          </template>

          <template v-slot:item.notifications[0].data.DOB="{ item }">
            <span v-if="item.notifications[0].data.DOB">{{
              item.notifications[0].data.DOB.substring(0, 10)
            }}</span>
            <span v-else><em>-</em></span>
          </template>

          <template v-slot:item.notifications[0].data.SOURCE_PTCLASS="{ item }">
            <v-chip dark :color="colorSourceClass(item.notifications[0].data.SOURCE_PTCLASS)">
              {{
                item.notifications[0].data.SOURCE_PTCLASS
                  ? item.notifications[0].data.SOURCE_PTCLASS
                  : "-"
              }}
            </v-chip>
          </template>

          <template v-slot:item.notifications[0].data.INSURANCE_COMPANY_NAME="{ item }">
            <span v-if="item.notifications[0].data.INSURANCE_COMPANY_NAME">{{
              item.notifications[0].data.INSURANCE_COMPANY_NAME
            }}</span>
            <span v-else><em>-</em></span>
          </template>

          <template v-slot:item.notifications[0].data.HOME_PHONE="{ item }">
            <span v-if="item.notifications[0].data.HOME_PHONE">{{
              item.notifications[0].data.HOME_PHONE
            }}</span>
            <span v-else><em>-</em></span>
          </template>

          <template v-slot:item.notifications[0].data.CELL_PHONE="{ item }">
            <span v-if="item.notifications[0].data.CELL_PHONE">{{
              item.notifications[0].data.CELL_PHONE
            }}</span>
            <span v-else><em>-</em></span>
          </template>

          <template v-slot:item.notifications[0].data.WORK_PHONE="{ item }">
            <span v-if="item.notifications[0].data.WORK_PHONE">{{
              item.notifications[0].data.WORK_PHONE
            }}</span>
            <span v-else><em>-</em></span>
          </template>

          <template slot="footer">
            <ExportCSV
              :data="this.dataForExport"
              :name="'Notifications ' + this.startDate + ' ' + this.endDate + '.csv'"
            >
              <v-btn color="secondary" text small class="export-button">Export to CSV</v-btn>
            </ExportCSV>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';
import ExportCSV from 'vue-json-csv';

export default {
  name: 'Notifications',
  props: [
    'insurance',
    'startDate',
    'endDate',
    'provider',
    'patient',
  ],
  components: {
    ExportCSV,
  },
  data: () => ({
    reportData: [],
    dataForExport: [],
    filterOptions: [
      'Expired', 
      'Home Health', 
      'Hospice', 
      'Long Term Care', 
      'Rehab', 
      'SNF'
    ],
    filterSelection: '',
    tableData: [],
    load: false,
    expanded: [],
    singleExpand: true,
    dropdownSelection: 'all',
    closeOnContentClick: true,
    search: '',
    headers: [
      { text: 'Date', value: 'notifications[0].DATE' },
      { text: 'Episode ID', value: '_id' },
      { text: 'Current Source PT Class', value: 'notifications[0].data.SOURCE_PTCLASS' },
      { text: 'Center Number', value: 'notifications[0].data.CENTER_NUMBER' },
      { text: 'Destination MRN', value: 'ID' },
      { text: 'Destination Facility', value: 'notifications[0].data.DEST_FACILITY' },
      { text: 'First Name', value: 'notifications[0].data.FNAME' },
      { text: 'Last Name', value: 'notifications[0].data.LNAME' },
      { text: 'Destination Practice', value: 'notifications[0].data.DEST_PRACTICE' },
      { text: 'Insurance', value: 'notifications[0].data.HALOS_INSURANCE' },
      { text: 'Gender', value: 'notifications[0].data.GENDER' },
      { text: 'DOB', value: 'notifications[0].data.DOB' },
      { text: 'Address', value: 'notifications[0].data.ADDR1' },
      { text: 'Home Phone', value: 'notifications[0].data.HOME_PHONE' },
      { text: 'Cell Phone', value: 'notifications[0].data.CELL_PHONE' },
    ],
  }),
  methods: {
    async getNotifications() {
      this.reportData = [];
      this.tableData = [];
      this.load = true;

      let { insurance } = this;
      let { startDate } = this;
      let { endDate } = this;
      let { provider } = this;
      let { patient } = this;

      await axios
        .get(`api/notifications/main/${insurance}/groups=/provs=${provider}/locs=/${startDate}/${endDate}/${patient}`)
        .then((res) => {
          this.reportData = res.data;
          this.tableData = res.data;
          this.load = false;

          this.prepareForExport();
        });
    },
    async prepareForExport() {
      this.dataForExport = [];

      this.reportData.forEach((n) => {
        n.notifications.forEach((notification) => {
          const record = {};

          const data = Object.entries(notification.data);

          for (const [key, value] of data) {
            record[key] = value;
          }

          this.dataForExport.push(record);
        });
      });
    },
    setFilter(value) {
      this.dropdownSelection = value;
    },
    colorEvent(value) {
      if (value === 'Admission') {
        return 'orange lighten-1';
      }
      if (value === 'Discharge') {
        return 'green lighten-1';
      }
    },
    colorSourceClass(value) {
      if (value === 'Inpatient') {
        return 'orange lighten-1';
      }
      if (value === 'Emergency') {
        return 'red lighten-1';
      }
    },
    getSelected() {
      this.load = true;
      const newArr = [];

      if (this.filterSelection === 'Expired') {
        this.reportData.forEach((item) => {
          item.notifications.forEach((n) => {
            if (
              n.data.DISCHARGE_DISPOSITION == 'EXP'
              || n.data.DISCHARGE_DISPOSITION == 'EXPIRED'
              || n.data.DISCHARGE_DISPOSITION == 'EXPIRED OR DID NOT RECOVER'
            ) {
              newArr.push(item);
            }
          });
        });
        // removes duplicate records from forEach before setting data
        this.tableData = this.filterData(newArr);
      } else if (this.filterSelection === 'Home Health') {
        this.reportData.forEach((item) => {
          item.notifications.forEach((n) => {
            if (
              n.data.DISCHARGE_DISPOSITION == 'HOME HEALTH SERVICE'
              || n.data.DISCHARGE_DISPOSITION == 'HOME UNDER CARE OF HOME HEALTH ORG'
            ) {
              newArr.push(item);
            }
          });
        });
        // removes duplicate records from forEach before setting data
        this.tableData = this.filterData(newArr);
      } else if (this.filterSelection === 'Hospice') {
        this.reportData.forEach((item) => {
          item.notifications.forEach((n) => {
            if (
              n.data.DISCHARGE_DISPOSITION == 'HOSPICE - HOME'
              || n.data.DISCHARGE_DISPOSITION == 'HOSPICE HOUS'
            ) {
              newArr.push(item);
            }
          });
        });
        // removes duplicate records from forEach before setting data
        this.tableData = this.filterData(newArr);
      } else if (this.filterSelection === 'Long Term Care') {
        this.reportData.forEach((item) => {
          item.notifications.forEach((n) => {
            if (n.data.DISCHARGE_DISPOSITION == 'LONG TERM ACUTE CARE FAC') {
              newArr.push(item);
            }
          });
        });
        // removes duplicate records from forEach before setting data
        this.tableData = this.filterData(newArr);
      } else if (this.filterSelection === 'Rehab') {
        this.reportData.forEach((item) => {
          item.notifications.forEach((n) => {
            if (n.data.DISCHARGE_DISPOSITION == 'Rehab Facility/Rehab Unit') {
              newArr.push(item);
            }
          });
        });
        // removes duplicate records from forEach before setting data
        this.tableData = this.filterData(newArr);
      } else if (this.filterSelection === 'SNF') {
        this.reportData.forEach((item) => {
          item.notifications.forEach((n) => {
            if (
              n.data.DISCHARGE_DISPOSITION == 'SKILLED NURSING FACILITY'
              || n.data.DISCHARGE_DISPOSITION == 'SKILLED NURSING FACILITY (SNF)'
              || n.data.DISCHARGE_DISPOSITION == 'SNF LMHS'
              || n.data.DISCHARGE_DISPOSITION == 'SNF/MC'
              || n.data.DISCHARGE_DISPOSITION == 'Skilled Nursing Facility - 03'
            ) {
              newArr.push(item);
            }
          });
        });
        // removes duplicate records from forEach before setting data
        this.tableData = this.filterData(newArr);
      } else {
        this.tableData = this.reportData;
      }
      this.load = false;
    },
    filterData(arr) {
      return arr.filter((item, index) => arr.indexOf(item) >= index);
    },
  },
  mounted() {
    this.getNotifications();
  },
  watch: {
    async insurance() {
      if (this.insurance !== []) {
        this.getNotifications();
      }
    },
    async startDate() {
      if (this.insurance !== []) {
        this.getNotifications();
      }
    },
    async endDate() {
      if (this.insurance !== []) {
        this.getNotifications();
      }
    },
  },
};
</script>

<style scoped>
.sub-notifications-header {
  text-align: left;
  padding-right: 60px;
}

.sub-notifications {
  padding-right: 20px;
}

.export-button {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
</style>
